import actions from "./actions";

const {
  VENDOR_LIST_DATA_BEGIN,
  VENDOR_LIST_DATA_SUCCESS,
  VENDOR_LIST_DATA_ERR,
  VENDOR_LIST_DATA_RESET,

  EXCHANGE_PROCESSING_DATA_BEGIN,
  EXCHANGE_PROCESSING_DATA_SUCCESS,
  EXCHANGE_PROCESSING_DATA_ERR,
  EXCHANGE_PROCESSING_DATA_RESET,

  CHECK_AFFORDABILITY_BEGIN,
  CHECK_AFFORDABILITY_SUCCESS,
  CHECK_AFFORDABILITY_ERR,
  CHECK_AFFORDABILITY_RESET,

  EXCHANGE_PROCESSING_SUBMIT_BEGIN,
  EXCHANGE_PROCESSING_SUBMIT_SUCCESS,
  EXCHANGE_PROCESSING_SUBMIT_ERR,
  EXCHANGE_PROCESSING_SUBMIT_RESET,

  EXCHANGE_DASHBOARD_DATA_BEGIN,
  EXCHANGE_DASHBOARD_DATA_SUCCESS,
  EXCHANGE_DASHBOARD_DATA_ERR,

  EXCHANGE_HISTORY_DATA_BEGIN,
  EXCHANGE_HISTORY_DATA_SUCCESS,
  EXCHANGE_HISTORY_DATA_ERR,

  INHOUSE_REFERENCE_HISTORY_DATA_BEGIN,
  INHOUSE_REFERENCE_HISTORY_DATA_SUCCESS,
  INHOUSE_REFERENCE_HISTORY_DATA_ERR,
  
  EXCHANGE_VIEW_DATA_BEGIN,
  EXCHANGE_VIEW_DATA_SUCCESS,
  EXCHANGE_VIEW_DATA_ERR,

  FILE_UPLOAD_BEGIN,
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_ERR,
  FILE_UPLOAD_RESET,

  EXCHANGE_PICKUP_DATA_SUBMIT_BEGIN,
  EXCHANGE_PICKUP_DATA_SUBMIT_SUCCESS,
  EXCHANGE_PICKUP_DATA_SUBMIT_ERR,
  EXCHANGE_PICKUP_DATA_RESET,

  INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_BEGIN,
  INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_SUCCESS,
  INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_ERR,
  INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_RESET,

  EXCHANGE_NEW_IMEI_LIST_BEGIN,
  EXCHANGE_NEW_IMEI_LIST_SUCCESS,
  EXCHANGE_NEW_IMEI_LIST_ERR,
  EXCHANGE_NEW_IMEI_LIST_RESET,

  ECHANGE_SCHEME_LIST_BEGIN,
  ECHANGE_SCHEME_LIST_SUCCESS,
  ECHANGE_SCHEME_LIST_ERR,
  ECHANGE_SCHEME_LIST_RESET,

  PAYMENT_METHOD_BEGIN,
  PAYMENT_METHOD_SUCCESS,
  PAYMENT_METHOD_ERR,
  PAYMENT_METHOD_RESET,

  SUBMIT_EXCHANGE_DATA_BEGIN,
  SUBMIT_EXCHANGE_DATA_SUCCESS,
  SUBMIT_EXCHANGE_DATA_ERR,
  SUBMIT_EXCHANGE_DATA_RESET,
  
  EXCHNAGE_INHOUSE_BEGIN,
  EXCHNAGE_INHOUSE_SUCCESS,
  EXCHNAGE_INHOUSE_ERR,
  EXCHNAGE_INHOUSE_RESET,
  
} = actions;

const initialState = { data: null, loading: false, error: null };
const initialFileUploadState = {
  video: { data: null, loading: false, error: null },
  pdf: { data: null, loading: false, error: null },
  pdf_affordability: { data: null, loading: false, error: null },
};

export const vendorListDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case VENDOR_LIST_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case VENDOR_LIST_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case VENDOR_LIST_DATA_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };

    case VENDOR_LIST_DATA_RESET:
      return initialState;

    default:
      return state;
  }
};

export const exchangeProcessingDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case EXCHANGE_PROCESSING_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case EXCHANGE_PROCESSING_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case EXCHANGE_PROCESSING_DATA_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };

    case EXCHANGE_PROCESSING_DATA_RESET:
      return initialState;

    default:
      return state;
  }
};

export const exchangeDashboardReducers = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case EXCHANGE_DASHBOARD_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case EXCHANGE_DASHBOARD_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case EXCHANGE_DASHBOARD_DATA_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };
    default:
      return state;
  }
};

export const getExchangeNewIMEIListDataReducer = (
  state = initialState,
  action,
) => {
  const { type, data, err } = action;
  switch (type) {
    case EXCHANGE_NEW_IMEI_LIST_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case EXCHANGE_NEW_IMEI_LIST_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case EXCHANGE_NEW_IMEI_LIST_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };

    case EXCHANGE_NEW_IMEI_LIST_RESET:
      return initialState;

    default:
      return state;
  }
};

export const getSchemeListDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ECHANGE_SCHEME_LIST_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case ECHANGE_SCHEME_LIST_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case ECHANGE_SCHEME_LIST_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };

    case ECHANGE_SCHEME_LIST_RESET:
      return initialState;

    default:
      return state;
  }
};

export const paymentMethodReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case PAYMENT_METHOD_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };

    case PAYMENT_METHOD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case PAYMENT_METHOD_RESET:
      return initialState;

    default:
      return state;
  }
};

export const checkAffordabilityReducer = (state = initialState, action) => {
  const { type, data, err } = action;

  switch (type) {
    case CHECK_AFFORDABILITY_BEGIN:
      return {
        ...initialState,
        loading: true,
      };

    case CHECK_AFFORDABILITY_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };

    case CHECK_AFFORDABILITY_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };

    case CHECK_AFFORDABILITY_RESET:
      return initialState;

    default:
      return state;
  }
};

export const fileUploadReducer = (state = initialFileUploadState, action) => {
  const { type, payload } = action;

  if (!payload && type !== FILE_UPLOAD_RESET) return state;

  switch (type) {
    case FILE_UPLOAD_BEGIN: {
      const { fileType } = payload;
      return {
        ...state,
        [fileType]: { data: null, loading: true, error: null },
      };
    }
    case FILE_UPLOAD_SUCCESS: {
      const { fileType, data } = payload;
      return { ...state, [fileType]: { data, loading: false, error: null } };
    }
    case FILE_UPLOAD_ERR: {
      const { fileType, err } = payload;
      return {
        ...state,
        [fileType]: { data: null, loading: false, error: err },
      };
    }
    case FILE_UPLOAD_RESET:
      return initialFileUploadState;
    default:
      return state;
  }
};

export const submitExchangeProcessingDataReducer = (
  state = initialState,
  action,
) => {
  const { type, data, err } = action;
  switch (type) {
    case EXCHANGE_PROCESSING_SUBMIT_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case EXCHANGE_PROCESSING_SUBMIT_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case EXCHANGE_PROCESSING_SUBMIT_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };
    case EXCHANGE_PROCESSING_SUBMIT_RESET:
      return initialState;
    default:
      return state;
  }
};

export const submitExchangeDataReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SUBMIT_EXCHANGE_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case SUBMIT_EXCHANGE_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case SUBMIT_EXCHANGE_DATA_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };
    case SUBMIT_EXCHANGE_DATA_RESET:
      return initialState;

    default:
      return state;
  }
};

// Exchange History View Details
export const exchangeHistoryReducers = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case EXCHANGE_HISTORY_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case EXCHANGE_HISTORY_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case EXCHANGE_HISTORY_DATA_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

export const inhouseReferenceHistoryReducers = (
  state = initialState,
  action,
) => {
  const { type, data, err } = action;
  switch (type) {
    case INHOUSE_REFERENCE_HISTORY_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case INHOUSE_REFERENCE_HISTORY_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case INHOUSE_REFERENCE_HISTORY_DATA_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

// Exchange View Details
export const exchangeViewReducers = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case EXCHANGE_VIEW_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case EXCHANGE_VIEW_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case EXCHANGE_VIEW_DATA_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };

    default:
      return state;
  }
};

//Exchange Pickup Data
export const submitExchangePickupDataReducer = (
  state = initialState,
  action,
) => {
  const { type, data, err } = action;
  switch (type) {
    case EXCHANGE_PICKUP_DATA_SUBMIT_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case EXCHANGE_PICKUP_DATA_SUBMIT_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case EXCHANGE_PICKUP_DATA_SUBMIT_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };
    case EXCHANGE_PICKUP_DATA_RESET:
      return initialState;
    default:
      return state;
  }
};

export const inhouseSubmitExchangePickupDataReducer = (
  state = initialState,
  action,
) => {
  const { type, data, err } = action;
  switch (type) {
    case INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_SUCCESS:
      return {
        ...initialState,
        data,
        error: null,
        loading: false,
      };
    case INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_ERR:
      return {
        ...initialState,
        error: err,
        data: null,
        loading: false,
      };
    case INHOUSE_SUBMIT_EXCHANGE_PICKUP_DATA_RESET:
      return initialState;
    default:
      return state;
  }
};



export const postExchnageInhouseDataReducers = (state = initialState, action) => { 
    const { type, data, err } = action;
    switch (type) {
        case EXCHNAGE_INHOUSE_BEGIN:
            return {
                ...initialState,
                loading: true,
            };
        case EXCHNAGE_INHOUSE_SUCCESS:
            return {    
                ...initialState,
                data,
                error:null,
                loading: false,
            };
        case EXCHNAGE_INHOUSE_ERR:
            return {
                ...initialState,
                error: err,
                data:null,
                loading: false,
            };  
        case EXCHNAGE_INHOUSE_RESET:
            return initialState;
        default:
            return state;
    }
}
